
                <div class="p-5">
                    <div class="text-center">
                        <h1 class="h4 text-gray-900 mb-4">Create an Account</h1>
                    </div>
                    <form class="user" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <input type="text" formControlName="name" class="form-control form-control-user"
                                placeholder="Name">
                        </div>
                        <div class="form-group">
                            <input type="text" formControlName="surname" class="form-control form-control-user"
                                placeholder="Surname">
                        </div>
                        <div class="form-group">
                            <input type="text" formControlName="mobile" class="form-control form-control-user"
                                placeholder="Mobile Number">
                        </div>
                        <div class="form-group">
                            <input type="email" formControlName="email" class="form-control form-control-user"
                                placeholder="Email Address">
                        </div>
                        <div class="form-group input-group">
                            <input name="password" type="password" placeholder="Password" id="password" name="password" [type]="passwordVisible?'text':'password'" class="form-control form-control-user"
                            formControlName="password" >
                            <div class="input-group-append">
                            <span class="input-group-text password-visibility" id="basic-addon2" (mousedown)="togglePassword(true)" (mouseup)="togglePassword(false)">
                                <fa-icon class="eye-icon" *ngIf="!passwordVisible" [icon]="faEye"></fa-icon> 
                                <fa-icon class="eye-icon" *ngIf="passwordVisible" [icon]="faEyeSlash"></fa-icon> 
                            </span>
                            </div>
                        </div>
                        <button type="submit" class="btn btn-primary btn-user btn-block">
                            Register Account
                        </button>
                    </form>
                    <hr>
                    <div class="text-center">
                        <button mat-button routerLink="/forgot-password">Forgot Password?</button>
                    </div>
                    <div class="text-center">
                        <button mat-button routerLink="/login">Already have an account? Login!</button>
                    </div>
                </div>
